// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutWrapperTopbar_root__YlnMo"};